import { createContext } from 'react';

import { type ContextoAuth as FormaDoContexto } from './tipos';

/**
 * O contexto vive em arquivo proprio, separado do provedor.
 *
 * Nao e capricho: arquivo que exporta componente E outra coisa perde a
 * atualizacao rapida do Vite em desenvolvimento — a cada salvamento o estado da
 * aplicacao inteira se perde, inclusive a sessao em memoria, que e justamente o
 * que este contexto guarda.
 */
export const ContextoAuth = createContext<FormaDoContexto | null>(null);
